export class RouterError extends Error {
	constructor(data) {
		super(`${data.fullPath} Not Found`); // (1)
		this.name = "RouterError"; // (2)
		this.data = data;
	}
}
